import { Injectable } from '@angular/core';
import { TableLazyLoadEvent } from 'primeng/table';

export interface PageRequest {
  pageNumber: number;
  pageSize: number;
}

@Injectable({ providedIn: 'root' })
export class PaginationService {
  mapLazyEventToPageRequest(
    event: TableLazyLoadEvent,
    currentPageSize: number
  ): PageRequest {
    const rows = event.rows ?? currentPageSize;
    const first = event.first ?? 0;

    const pageIndex = Math.floor(first / rows);
    const pageNumber = pageIndex + 1;

    return {
      pageNumber,
      pageSize: rows,
    };
  }

  pageToFirst(pageNumber: number, pageSize: number): number {
    return (pageNumber - 1) * pageSize;
  }
}
